/* =========================================================
   Heatronics - the tab sections ("Explore Heatronics hCore"
   and any other .ht-nav section). Pairs with
   assets/tabs-mobile.css.

   TWO JOBS.

   A. A BUG FIX THAT APPLIES AT EVERY WIDTH.
      The section's own tab handler throws "$ is not a function"
      partway through - $ is not jQuery in that scope - so the
      setPosition call that a slick carousel needs when it comes
      out of a hidden tab never runs. A carousel initialised
      while hidden cannot measure anything, so the panel opens
      1246px too tall: on desktop, clicking a tab in this
      section takes it from 612px to 1858px and the page from
      4519px to 5766px, and it stays that way. One setPosition
      after the class change puts it back to 612. The handler
      can also leave two panels visible at once, so the active
      pill is used as the source of truth for which panel shows.

   B. ON A PHONE ONLY, the slick carousel is replaced by a
      native scroll-snap rail so the next card peeks.

   WHY THE CAROUSEL IS REMOVED RATHER THAN RECONFIGURED
   The obvious fix for the peek is a fractional slidesToShow.
   Slick does compute the narrower slide (334 -> 293) but never
   rewrites the track transform to match, so every card lands
   41px out of position; setPosition, slickGoTo and a synthetic
   resize all left the stale transform in place. A native rail
   is the better mobile control anyway: real momentum, no touch
   emulation, no clones.

   WHY IT NEVER RE-INITIALISES SLICK
   An earlier version restored the carousel when the viewport
   crossed back above 750px. Re-initialising slick on a HIDDEN
   panel is exactly the bug in A, and produced a 4254px tall
   slick-list. So the takeover is one-way per page load, and the
   stylesheet carries a three-up fallback for a rail that finds
   itself on a wide screen.

   THREE OTHER THINGS THAT EACH COST A ROUND TRIP:
   1. This script is deferred and slick initialises later, and
      the section then initialises it AGAIN. So every sweep
      re-checks elements it has already claimed, and a
      MutationObserver re-takes one if the slick class returns.
   2. offsetLeft is measured against the nearest POSITIONED
      ancestor, and the pill list is position: static - the pill
      offsets were being read against .ht-body, 409px out. Rects
      plus scrollLeft are used instead.
   3. scrollTo({behavior:'smooth'}) on an overflow container is
      not reliably honoured - it silently did nothing in
      testing. The pill rail is tweened on rAF instead, which
      also lets the edge fades repaint as it moves.
   ========================================================= */
(function () {
  var MOBILE = '(max-width: 749px)';
  var NUDGE_KEY = 'hb-tab-nudged';

  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function $j() { return window.jQuery; }

  /* ---------- A. the section's own bugs ----------------- */

  function visiblePanel(section) {
    var panels = section.querySelectorAll('.ht-panel');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].classList.contains('ht-panel--hidden')) return panels[i];
    }
    return null;
  }

  function onePanelOnly(section) {
    var nav = section.querySelector('.ht-nav');
    if (!nav) return;
    var links = nav.querySelectorAll('.ht-nav-link');
    var idx = -1;
    for (var i = 0; i < links.length; i++) {
      if (links[i].classList.contains('ht-nav-link--active')) { idx = i; break; }
    }
    if (idx < 0) return;
    var panels = section.querySelectorAll('.ht-panel');
    if (panels.length !== links.length) return;
    for (var p = 0; p < panels.length; p++) {
      if (p === idx) panels[p].classList.remove('ht-panel--hidden');
      else panels[p].classList.add('ht-panel--hidden');
    }
  }

  // the setPosition the section meant to call
  function remeasure(section) {
    var jq = $j();
    if (!jq || !jq.fn || !jq.fn.slick) return;
    var panel = visiblePanel(section);
    if (!panel) return;
    var el = panel.querySelector('.ht-slick');
    if (!el || !el.classList.contains('slick-initialized')) return;
    try { jq(el).slick('setPosition'); } catch (e) {}
  }

  /* ---------- B. taking the carousel over (phone) ------- */

  function unslick(el) {
    var jq = $j();
    if (!el.classList.contains('slick-initialized')) return true;
    // slick is back: stand the CSS down before doing anything
    if (el.dataset.htmRail === '1') delete el.dataset.htmRail;
    if (!jq || !jq.fn || !jq.fn.slick) return false;
    try { jq(el).slick('unslick'); } catch (e) {}
    return !el.classList.contains('slick-initialized');
  }

  function guard(el) {
    if (el.dataset.htmGuard === '1' || !window.MutationObserver) return;
    el.dataset.htmGuard = '1';
    var pending = null;
    var obs = new window.MutationObserver(function () {
      if (!isMobile() || !el.classList.contains('slick-initialized')) return;
      delete el.dataset.htmRail;
      window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        if (isMobile() && unslick(el)) {
          el.dataset.htmRail = '1';
          wireRail(el);
        }
      }, 60);
    });
    obs.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function toRail(section) {
    var slicks = section.querySelectorAll('.ht-slick');
    var allDone = true;
    for (var i = 0; i < slicks.length; i++) {
      var el = slicks[i];
      if (!unslick(el)) { allDone = false; continue; }
      el.dataset.htmRail = '1';
      guard(el);
    }
    return allDone;
  }

  /* ---------- a scroll tween that always works ---------- */

  function tweenScroll(el, to, onFrame) {
    var from = el.scrollLeft;
    var delta = to - from;
    if (Math.abs(delta) < 1) { if (onFrame) onFrame(); return; }
    if (reducedMotion()) {
      el.scrollLeft = to;
      if (onFrame) onFrame();
      return;
    }
    var DUR = 320;
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min((ts - start) / DUR, 1);
      var e = 1 - Math.pow(1 - t, 3);
      el.scrollLeft = from + delta * e;
      if (onFrame) onFrame();
      if (t < 1) window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  /* ---------- progress bar ------------------------------ */

  function progressFor(rail) {
    var host = rail.parentNode;
    if (!host) return null;
    var bar = null;
    for (var i = 0; i < host.children.length; i++) {
      if (host.children[i].className === 'htm-prog') { bar = host.children[i]; break; }
    }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'htm-prog';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span class="htm-prog__bar"></span>';
      host.appendChild(bar);
    }
    return bar;
  }

  function paintProgress(rail) {
    var bar = progressFor(rail);
    if (!bar) return;
    var inner = bar.firstElementChild;
    var max = rail.scrollWidth - rail.clientWidth;
    if (max < 4 || rail.dataset.htmRail !== '1') { bar.hidden = true; return; }
    bar.hidden = false;
    var frac = rail.clientWidth / rail.scrollWidth;
    var w = Math.max(frac * 100, 14);
    var travel = bar.clientWidth * (1 - w / 100);
    var x = Math.max(0, Math.min(rail.scrollLeft / max, 1)) * travel;
    inner.style.width = w + '%';
    inner.style.transform = 'translateX(' + x + 'px)';
  }

  // follow the finger: scroll events are throttled or dropped
  // during momentum, so poll while a gesture is in flight
  function follow(rail) {
    if (rail.htmFollowing) { rail.htmFollowUntil = Date.now() + 900; return; }
    rail.htmFollowing = true;
    rail.htmFollowUntil = Date.now() + 900;
    var last = -1;
    (function frame() {
      if (rail.scrollLeft !== last) {
        last = rail.scrollLeft;
        paintProgress(rail);
        rail.htmFollowUntil = Math.max(rail.htmFollowUntil, Date.now() + 300);
      }
      if (Date.now() < rail.htmFollowUntil) {
        window.requestAnimationFrame(frame);
      } else {
        rail.htmFollowing = false;
        paintProgress(rail);
      }
    })();
  }

  function wireRail(rail) {
    if (rail.dataset.htmWired !== '1') {
      rail.dataset.htmWired = '1';
      rail.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { paintProgress(rail); });
      }, { passive: true });
      rail.addEventListener('touchstart', function () { follow(rail); }, { passive: true });
      rail.addEventListener('pointerdown', function () { follow(rail); }, { passive: true });
      rail.addEventListener('wheel', function () { follow(rail); }, { passive: true });
    }
    paintProgress(rail);
  }

  /* ---------- the one-time swipe nudge ------------------ */

  function nudge(rail) {
    if (reducedMotion()) return;
    if (rail.scrollWidth - rail.clientWidth < 20) return;
    try {
      if (window.sessionStorage.getItem(NUDGE_KEY) === '1') return;
      window.sessionStorage.setItem(NUDGE_KEY, '1');
    } catch (e) {}

    rail.classList.add('is-nudging');
    var start = null;
    var PEAK = 28;
    var DUR = 760;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min((ts - start) / DUR, 1);
      var e = Math.sin(t * Math.PI);
      rail.scrollLeft = PEAK * e * e;
      paintProgress(rail);
      if (t < 1) {
        window.requestAnimationFrame(step);
      } else {
        rail.scrollLeft = 0;
        rail.classList.remove('is-nudging');
        paintProgress(rail);
      }
    }
    window.requestAnimationFrame(step);
  }

  /* ---------- tab pills --------------------------------- */

  function paintNavEdges(nav) {
    var max = nav.scrollWidth - nav.clientWidth;
    if (max < 4) { nav.dataset.at = 'none'; return; }
    if (nav.scrollLeft <= 2) nav.dataset.at = 'start';
    else if (nav.scrollLeft >= max - 2) nav.dataset.at = 'end';
    else nav.dataset.at = 'middle';
  }

  function centreActive(nav) {
    var active = nav.querySelector('.ht-nav-link--active');
    if (!active) return;
    var li = (active.parentNode && active.parentNode.tagName === 'LI') ? active.parentNode : active;
    var navRect = nav.getBoundingClientRect();
    var liRect = li.getBoundingClientRect();
    var within = liRect.left - navRect.left + nav.scrollLeft;
    var target = within - (nav.clientWidth - liRect.width) / 2;
    var max = nav.scrollWidth - nav.clientWidth;
    tweenScroll(nav, Math.max(0, Math.min(target, max)), function () { paintNavEdges(nav); });
  }

  function onTabChange(section, nav) {
    onePanelOnly(section);
    if (!isMobile()) {
      // desktop: just give slick the measurement it never got
      remeasure(section);
      window.setTimeout(function () { remeasure(section); }, 120);
      return;
    }
    centreActive(nav);
    window.setTimeout(function () {
      toRail(section);
      onePanelOnly(section);
      refreshVisible(section);
    }, 80);
  }

  function wireNav(nav, section) {
    if (nav.dataset.htmWired === '1') { paintNavEdges(nav); return; }
    nav.dataset.htmWired = '1';

    nav.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { paintNavEdges(nav); });
    }, { passive: true });
    nav.addEventListener('touchmove', function () { paintNavEdges(nav); }, { passive: true });

    // the section toggles --active itself; follow that rather than
    // binding clicks, so this keeps working if that code changes
    if (window.MutationObserver) {
      var obs = new window.MutationObserver(function () {
        onTabChange(section, nav);
      });
      obs.observe(nav, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    paintNavEdges(nav);
    if (isMobile()) centreActive(nav);
  }

  /* ---------- wiring ------------------------------------ */

  function refreshVisible(section) {
    var panel = visiblePanel(section);
    if (!panel) return;
    var rail = panel.querySelector('.ht-slick');
    if (!rail || rail.dataset.htmRail !== '1') return;
    wireRail(rail);
    rail.scrollLeft = 0;
    paintProgress(rail);
  }

  function armNudge(section) {
    if (section.dataset.htmSeen === '1') return;
    if (!('IntersectionObserver' in window)) return;
    section.dataset.htmSeen = '1';
    var io = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.disconnect();
        var panel = visiblePanel(section);
        var rail = panel && panel.querySelector('.ht-slick');
        if (rail && rail.dataset.htmRail === '1') {
          window.setTimeout(function () { nudge(rail); }, 420);
        }
      }
    }, { threshold: 0.35 });
    io.observe(section);
  }

  function apply(section) {
    var nav = section.querySelector('.ht-nav');
    if (nav) wireNav(nav, section);

    if (!isMobile()) return true;   // desktop keeps its carousel

    var done = toRail(section);
    onePanelOnly(section);
    refreshVisible(section);
    if (done) armNudge(section);
    return done;
  }

  function applyAll(scope) {
    var navs = (scope || document).querySelectorAll('.ht-nav');
    var done = true;
    for (var i = 0; i < navs.length; i++) {
      var section = navs[i].closest ? navs[i].closest('[id^="shopify-section"]') : null;
      if (section && !apply(section)) done = false;
    }
    return done;
  }

  function boot() {
    var delays = [250, 600, 1200, 2400, 4000, 6000];
    applyAll();
    for (var i = 0; i < delays.length; i++) {
      window.setTimeout(function () { applyAll(); }, delays[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var t;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(function () { applyAll(); }, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    window.setTimeout(function () { applyAll(e.target); }, 200);
  });
})();
